import { cn } from '@/ui/utils/classnames';
import type { RenderItemFn } from './parts/item.js';
import Item from './parts/item.js';

export interface ScrollableListProps<I> {
  items: I[];
  renderItem: RenderItemFn<I>;
  getItemKey: (item: I) => string;
  getClickHandler?: (item: I) => (() => void) | null;
  className?: string;
  forceBorder?: boolean;
  topBorder?: boolean;
}

function ScrollableList<I>({
  items,
  renderItem,
  getItemKey,
  className,
  forceBorder = false,
  topBorder = false,
  getClickHandler = () => null,
}: ScrollableListProps<I>) {
  return (
    <div
      className={cn(
        'w-[calc(100%+32px)] overflow-y-auto px-4 scrollbar-hide',
        className,
      )}
    >
      <ul
        className={cn(
          'flex w-full flex-col divide-y divide-solid divide-black/6',
          forceBorder
            ? 'theme-dark:divide-neutral-600'
            : 'theme-dark:divide-none',
          topBorder && 'border-t border-solid border-black/6',
          topBorder && forceBorder && 'theme-dark:border-neutral-600',
          topBorder && !forceBorder && 'theme-dark:border-none',
        )}
      >
        {items.map((item) => {
          return (
            <li key={getItemKey(item)} className="w-full">
              <Item
                item={item}
                renderItem={renderItem}
                onClick={getClickHandler(item)}
              />
            </li>
          );
        })}
      </ul>
    </div>
  );
}

export default ScrollableList;
